import { type FC, type ReactNode } from 'react';
import { Link } from 'dibs-elements/exports/Link.tsx';
import { NumberInput } from 'dibs-elements/exports/NumberInput.tsx';
import Plus from 'dibs-icons/exports/legacy/Plus.ts';
import Minus from 'dibs-icons/exports/legacy/Minus.ts';

import styles from './EditionsCounter.scss';

type Props = {
    balance: number | null;
    maxBalance: number | null;
    setBalance: (balance: number | null) => void;
    label: ReactNode;
    maxBalanceMessage?: ReactNode;
};

export const EditionsCounter: FC<Props> = ({
    balance,
    maxBalance,
    setBalance,
    label,
    maxBalanceMessage,
}) => {
    return (
        <>
            {maxBalanceMessage && <p className={styles.maxEditionsMessage}>{maxBalanceMessage}</p>}
            <div className={styles.inputContainer}>
                <p className={styles.inputLabel}>{label}</p>
                {(maxBalance && maxBalance > 1) || !maxBalance ? (
                    <div className={styles.counterContainer}>
                        <Link
                            onClick={() => {
                                if (balance && balance > 1) {
                                    setBalance(balance - 1);
                                } else if (!balance) {
                                    setBalance(1);
                                }
                            }}
                            className={styles.changeAmountButton}
                        >
                            <Minus className={styles.changeAmountIcon} />
                        </Link>
                        <div className={styles.numberInput}>
                            <NumberInput
                                value={balance}
                                onChange={value => {
                                    if (
                                        (value && value > 0 && maxBalance && value <= maxBalance) ||
                                        (value && value > 0 && !maxBalance)
                                    ) {
                                        setBalance(value);
                                    } else if (!value) {
                                        setBalance(null);
                                    }
                                }}
                                dataTn="transfer-balance"
                                size="small"
                                horizontalSpacing="small"
                            />
                        </div>
                        <Link
                            onClick={() => {
                                if (
                                    (balance && maxBalance && balance < maxBalance) ||
                                    (balance && !maxBalance)
                                ) {
                                    setBalance(balance + 1);
                                } else if (!balance) {
                                    setBalance(1);
                                }
                            }}
                            className={styles.changeAmountButton}
                        >
                            <Plus className={styles.changeAmountIcon} />
                        </Link>
                    </div>
                ) : (
                    <span>1</span>
                )}
            </div>
        </>
    );
};
